import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchAreaInfo: (data) => {
        return repository.post(`${common_resource}/postCommonAreaInfo`, {
            ...data
        });
    }
};
